/**
 * Created by RSchweber-Koren on 3/27/2017.
 */
const operationCancelledMessage = "The current tracking calendar data operation was cancelled";

class TrackingCalendarDataOperationCancelledError extends Error {
    constructor(currentOperationName, ...otherArgs) {
        super(operationCancelledMessage);
        this.name = "TrackingCalendarDataOperationCancelledError";
        this.operationName = currentOperationName;
        this.errorData = otherArgs;
    }
}

export default TrackingCalendarDataOperationCancelledError;


//////////////////
// WEBPACK FOOTER
// ./src/models/errors/TrackingCalendarDataOperationCancelledError.js
// module id = 3DU0
// module chunks = 1